module.exports = __webpack_public_path__ + "img/logo_gie_parcial.fb9f0a3d.png";